import { Link, useLocation } from 'react-router-dom'
import { Home, Users, Settings, MessageCircleHeart, MessagesSquare, Logs } from 'lucide-react'
import { cn } from '../../lib/utils'
import logo from '../../logo.png'


const links = [
  { name: 'Dashboard', path: '/dashboard', icon: Home },
  { name: 'Users', path: '/admin/users', icon: Users },
  { name: 'User Activities', path: '/admin/activities', icon: Logs },
  { name: 'Feedback', path: '/admin/feedback', icon: MessageCircleHeart },
  { name: 'Conversations', path: '/admin/conversations', icon: MessagesSquare }
]

interface SidebarProps {
  isMobileOpen: boolean;
  setIsMobileOpen: (open: boolean) => void;
}

export default function Sidebar({ isMobileOpen, setIsMobileOpen }: SidebarProps) {
  const location = useLocation()

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="w-64 hidden md:flex flex-col bg-gray-900 text-white h-screen sticky top-0 shadow-md">
        <div className="p-4 text-xl font-bold border-b border-gray-700">
        <img src={logo} alt="Logo" className="w-1/2 bg-white m-auto" />
        </div>
        <nav className="flex flex-col gap-1 mt-4">
          {links.map(({ name, path, icon: Icon }) => (
        <Link
          key={path}
          to={path}
          className={cn(
            'flex items-center gap-3 px-4 py-2 hover:bg-gray-800 transition',
            location.pathname.startsWith(path) && 'bg-gray-800 font-semibold'
          )}
        >
          <Icon size={18} />
          {name}
        </Link>
          ))}
        </nav>
      </aside>

      {/* Mobile Sidebar */}
      {isMobileOpen && (
        <div className="fixed inset-0 z-50 flex md:hidden">
          <div className="w-64 bg-gray-900 text-white flex flex-col shadow-lg">
            <div className="p-4 text-xl font-bold border-b border-gray-700">
            <img src={logo} alt="Logo" className="h-10 mb-2" />
            </div>
            <nav className="flex flex-col gap-1 mt-4">
              {links.map(({ name, path, icon: Icon }) => (
                <Link
                  key={path}
                  to={path}
                  onClick={() => setIsMobileOpen(false)}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2 hover:bg-gray-800 transition',
                    location.pathname === path && 'bg-gray-800 font-semibold'
                  )}
                >
                  <Icon size={18} />
                  {name}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex-1 bg-black/40" onClick={() => setIsMobileOpen(false)}></div>
        </div>
      )}
    </>
  )
}